/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet, ActivityIndicator } from 'react-native';
import Colors from '@global/colors';

const LoaderTotal = () => {
  return (
    <View style={styles.loader}>
      <ActivityIndicator size={25} color={Colors.blue0} />
    </View>
  );
};

const styles = StyleSheet.create({
  loader: { fontSize: 24, marginBottom: 10, width: 25 },
});

export default React.memo(LoaderTotal, (prev, next) => prev == next);
